<template>
  <div class="container mx-auto p-4 max-w-4xl">
    <h1 class="text-3xl font-bold mb-8 text-gray-800">隐私政策</h1>
    
    <div class="space-y-8 text-gray-700">
      <section>
        <h2 class="text-2xl font-semibold mb-4 text-gray-800">前言</h2>
        <p class="leading-relaxed">
          《笔记应用隐私政策》（以下称"本政策"）适用于我们提供的笔记服务（以下简称"本服务"）。
          您在使用本服务前，请仔细阅读本政策，以了解我们处理您个人信息的详情。
          我们一向庄严承诺保护使用本服务的用户（以下统称"用户"或"您"）的个人信息和隐私安全。
        </p>
      </section>

      <section>
        <h2 class="text-2xl font-semibold mb-4 text-gray-800">数据收集及使用说明</h2>
        <ul class="list-disc pl-6 space-y-3">
          <li>我们会收集关于您使用本应用的相关信息，例如使用频率和您使用的功能。这些数据会进行汇总处理，不会识别到具体个人。</li>
          <li>在您使用笔记功能时，我们将收集您创建的内容（包括文本、图片），我们会对上述信息进行存储，以便于为您提供笔记服务。</li>
          <li>如果您登录账户系统，我们需要您提供电子邮箱地址，这将作为您的身份标识、登录名和找回密码的途径。</li>
          <li>我们会收集您的设备信息（如设备 ID，浏览器型号和版本），以改善我们的服务。</li>
          <li>我们可能会收集并使用您的 IP 地址信息，以确定您所在的国家或地区，提供本地化的服务内容。</li>
        </ul>
      </section>

      <section>
        <h2 class="text-2xl font-semibold mb-4 text-gray-800">数据存储和安全</h2>
        <ul class="list-disc pl-6 space-y-3">
          <li>您的所有笔记内容都经过加密存储。</li>
          <li>我们采用行业标准的安全技术来保护您的个人信息。</li>
          <li>我们定期进行安全评估和系统更新，以确保您的数据安全。</li>
        </ul>
      </section>

      <section>
        <h2 class="text-2xl font-semibold mb-4 text-gray-800">数据共享情况</h2>
        <p class="leading-relaxed">
          我们不会将您的个人数据与第三方共享，除非：
        </p>
        <ul class="list-disc pl-6 space-y-3 mt-3">
          <li>获得您的明确同意</li>
          <li>法律法规要求</li>
          <li>维护我们的合法权益所必需</li>
        </ul>
      </section>

      <section>
        <h2 class="text-2xl font-semibold mb-4 text-gray-800">您的权利</h2>
        <ul class="list-disc pl-6 space-y-3">
          <li>您可以随时查看、更新或删除您的个人信息</li>
          <li>您可以通过联系我们来注销账号</li>
          <li>您可以选择退出我们的服务</li>
        </ul>
      </section>

      <section>
        <h2 class="text-2xl font-semibold mb-4 text-gray-800">联系我们</h2>
        <p class="leading-relaxed">
          如果您对本隐私政策有任何疑问或建议，请通过以下方式联系我们：
        </p>
        <div class="mt-3">
          <p>邮箱：postmaster@miaoji360.top</p>
          <p>地址：山东省青岛市均和云谷青岛未来创新园8号楼</p>
        </div>
      </section>

      <section class="text-sm text-gray-500">
        <p>最后更新时间：2025年04月30日</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyView'
}
</script> 